import { render, staticRenderFns } from "./MenuEditTemporaryStudent.vue?vue&type=template&id=6a6252b9&scoped=true&lang=pug&"
import script from "./MenuEditTemporaryStudent.vue?vue&type=script&lang=ts&"
export * from "./MenuEditTemporaryStudent.vue?vue&type=script&lang=ts&"
import style0 from "./MenuEditTemporaryStudent.vue?vue&type=style&index=0&id=6a6252b9&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6252b9",
  null
  
)

export default component.exports